export class LocationPoint {
  easting: number;
  northing: number;

  constructor(easting: number, northing: number) {
    this.easting = easting;
    this.northing = northing;
  }
}
